/**
 * Состояние онбординг-хинта «установите аватар», индивидуально по пользователю
 * (localStorage по id). Шаги:
 *  0      — хинт на кнопке вызова пользовательского меню;
 *  1      — хинт на кнопке аватара (после первого открытия меню);
 *  'done' — больше не показывать (после клика по аватару).
 */
export type OnboardingHintStep = 0 | 1 | 'done';
export type AvatarHintStep = OnboardingHintStep;

const storageKey = (userId: number | string) => `avatarHintStep:${userId}`;

export function getAvatarHintStep(userId: number | string): AvatarHintStep {
    try {
        const v = localStorage.getItem(storageKey(userId));
        if (v === 'done') return 'done';
        if (v === '1') return 1;
        return 0;
    } catch {
        // localStorage недоступен — не навязываем хинт
        return 'done';
    }
}

export function persistAvatarHintStep(userId: number | string, step: 1 | 'done'): void {
    try {
        localStorage.setItem(storageKey(userId), String(step));
    } catch {
        /* localStorage недоступен — просто не сохраняем */
    }
}

// Версия в ключе нужна, чтобы следующую заметную переработку переключателя можно было
// анонсировать отдельно, не возвращая уже просмотренную подсказку этой версии.
const themeStorageKey = (userId: number | string) => `themeSwitchHintStep:v1:${userId}`;

export function getThemeHintStep(userId: number | string): OnboardingHintStep {
    try {
        const value = localStorage.getItem(themeStorageKey(userId));

        if (value === 'done') return 'done';
        if (value === '1') return 1;
        return 0;
    } catch {
        // localStorage недоступен — не показываем подсказку при каждом открытии приложения.
        return 'done';
    }
}

export function persistThemeHintStep(userId: number | string, step: 1 | 'done'): void {
    try {
        localStorage.setItem(themeStorageKey(userId), String(step));
    } catch {
        /* localStorage недоступен — просто не сохраняем */
    }
}

// Подсказка про показ экрана поддержке: шаг 0 — у кнопки «Помощь», шаг 1 — карточка у пункта «Показать экран
// поддержке» в открытом меню. Версия в ключе — как у темы.
const screenShareStorageKey = (userId: number | string) => `screenShareHintStep:v1:${userId}`;

export function getScreenShareHintStep(userId: number | string): OnboardingHintStep {
    try {
        const value = localStorage.getItem(screenShareStorageKey(userId));

        if (value === 'done') return 'done';
        if (value === '1') return 1;
        return 0;
    } catch {
        // localStorage недоступен — не показываем подсказку при каждом открытии приложения.
        return 'done';
    }
}

export function persistScreenShareHintStep(userId: number | string, step: 1 | 'done'): void {
    try {
        localStorage.setItem(screenShareStorageKey(userId), String(step));
    } catch {
        /* localStorage недоступен — просто не сохраняем */
    }
}
